// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import UnitedStatesMinorOutlyingIslands from '../_raw/flag/icon_flag_united_states_minor_outlying_islands.png';

export default () => (
  <img src={UnitedStatesMinorOutlyingIslands} alt="UnitedStatesMinorOutlyingIslands" />
);
